// Save an axios blob response as a file. Same mechanics as doDownloadQRCodeCard in
// reducer_card_management.js, pulled out so every export shares one implementation.

/** Prefer the filename the server set in Content-Disposition; fall back to a dated name. */
export function triggerBlobDownload(response, fallbackPrefix) {
    const cd = (response && response.headers && response.headers["content-disposition"]) || "";
    const m = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(cd);
    const name = m ? decodeURIComponent(m[1]) : fallbackPrefix + "_" + stamp() + ".xlsx";

    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}

/**
 * With responseType:"blob" an API error body ALSO arrives as a Blob, so the usual
 * error.response.data.errorMessage is unreadable until the blob is decoded.
 */
export async function blobErrorMessage(error, fallback = "Export failed. Please try again.") {
    try {
        const data = error && error.response && error.response.data;
        if (data instanceof Blob) {
            const parsed = JSON.parse(await data.text());
            return parsed.errorMessage || parsed.message || fallback;
        }
        if (data && typeof data === "object") return data.errorMessage || data.message || fallback;
    } catch (_) {
        // not JSON — fall through to the generic message
    }
    return (error && error.message) || fallback;
}

function stamp() {
    const d = new Date();
    const p = (n) => String(n).padStart(2, "0");
    return d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + "_" + p(d.getHours()) + p(d.getMinutes());
}

/**
 * GET an export endpoint and save the .xlsx. Returns null on success or an error message.
 * Empty params are dropped so the server sees exactly the filters on screen.
 */
export async function exportToExcel(url, params, fallbackPrefix) {
    const axios = (await import("axios")).default;
    const clean = {};
    Object.entries(params || {}).forEach(([k, v]) => {
        if (v !== undefined && v !== null && v !== "") clean[k] = v;
    });
    try {
        const response = await axios.get(url, { params: clean, responseType: "blob" });
        triggerBlobDownload(response, fallbackPrefix);
        return null;
    } catch (error) {
        return blobErrorMessage(error);
    }
}
